<template>
  <BaseDialog :isOpen="isOpen">
    <template v-slot:title>
      <span>Are you sure you want to cancel the booking?</span>
    </template>
    <template v-slot:body>
      <div class="cancel-booking-description">
        Cancelling the booking will reject all candidates, and cancel all
        allocations. This can’t be reversed.
      </div>
    </template>
    <template v-slot:actions>
      <div class="cancel-booking-actions">
        <PrimaryButton @click.native="cancel" text>
          Cancel
        </PrimaryButton>
        <ErrorButton @click.native="handleSubmit" :loading="isLoading">
          Cancel Booking
        </ErrorButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ErrorButton from "@/components/common/Button/ErrorButton";
import {
  BOOKINGS_NAMESPACE,
  CANCEL_BOOKING
} from "@/store/modules/bookings/actions";
import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers(BOOKINGS_NAMESPACE);

export default {
  name: "CancelBookingDialog",
  components: { ErrorButton, PrimaryButton, BaseDialog },
  props: {
    isOpen: Boolean
  },
  data() {
    return {
      isLoading: false
    };
  },
  inject: ["currentBookingId"],
  methods: {
    ...mapActions({
      cancelBooking: CANCEL_BOOKING
    }),
    async handleSubmit() {
      this.isLoading = true;
      try {
        await this.cancelBooking(this.currentBookingId);
        this.$emit("close");
      } finally {
        this.isLoading = false;
      }
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.cancel-booking-description {
  min-height: 100px;
}
</style>
